import {Component, AfterViewInit, ViewChild} from '@angular/core';
import {MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteTrigger as MatAutocompleteTrigger} from '@angular/material/legacy-autocomplete';
import {MatLegacyButton as MatButton} from '@angular/material/legacy-button';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {MatLegacyInput as MatInput} from '@angular/material/legacy-input';
import {MatSort,Sort} from '@angular/material/sort';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {HttpClient} from '@angular/common/http';
import {IdexService} from 'app/idex.service';
import {Toast} from 'app/shared/toast/toast';
import {SelectionModel} from '@angular/cdk/collections';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmDialogComponent} from '../../e-signature/confirm-dialog/confirm-dialog.component';
import {AddGroupCompanyComponent } from '../add-group-company/add-group-company.component';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {PaginatorComponent} from '../../shared/paginator/paginator.component';
import {AdminApi, Site} from '../admin-api';
import { AddToSiteComponent } from '../add-to-site/add-to-site.component';

export interface Group {
   group: string;
   siteCode: string;
   expanded: true;
}

export interface Member extends UserData {
   no: number;
   siteCode: string;
   siteName: string;
}

@Component({
  selector: 'app-group-company',
  templateUrl: './group-company.component.html',
  styleUrls: ['./group-company.component.css']
})
export class GroupCompanyComponent implements AfterViewInit {
   isAddGroup: any;
   isLoadingResults = true;
   isRateLimitReached = false;
   resultsLength = 0;
   errorMessage: string;
   contactType: string;
   selectTabIndex = 0;
   user_role: any;
   selectedRowIndex = -1;
   clickActive: boolean;
   roles = [
      {value: 'Admin', viewValue: 'Admin'},
      {value: 'Editor', viewValue: 'Editor'},
      {value: 'Moderator', viewValue: 'Moderator'},
      {value: 'Member', viewValue: 'Member'}
   ];
   displayedColumns = ['select','no', 'fullName','members','menu'];
   dataSource: MatTableDataSource<UserData | Group>;
   selection = new SelectionModel<any>(true, []);
   error_email = false;
   show = true;
   filterContactValue = '';
   pageSize = 50;
   listSite: Site[] = [];
   allGroup: Group[] = [];
   allMember: Member[] = [];
   listmember: Member[] = [];
   tin: any;
   user: any;
   groups: UserData[];

   role: string;
   isAdmin: boolean;

   searching: any;
   searchFocused: boolean;
   preventBlur: boolean;
   searchResult: any[];
   searchvalue: any;
   searchSize = 8;
   private timer: any;
   sortEvent = {'active': 'fullName', 'direction': 'asc'};

   @ViewChild('txtContactId') public txtContId: MatInput;
   @ViewChild('fullName') public txtFullName;
   @ViewChild('groupName') public txtGroupName;
   @ViewChild('email') public txtEmail: MatInput;
   @ViewChild('btnDelContact', { static: true }) public buttonDel: MatButton;
   @ViewChild('btnSite', { static: true }) public buttonSite: MatButton;
   @ViewChild(PaginatorComponent, {static: true}) paginator: PaginatorComponent;
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;

   @ViewChild(MatAutocompleteTrigger)
   private trigger: MatAutocompleteTrigger;

   private addgroupDialog: MatDialogRef<AddGroupCompanyComponent>;
   private addtositeDialog: MatDialogRef<AddToSiteComponent>;

   defaultSort: Sort = {active: 'name', direction: 'asc'};

   constructor(public service: IdexService,
               public toast: Toast,
               public dialog: MatDialog,
               private translate: TranslateService,
               private adminService: AdminApi) {
      this.user = this.service.user;
      this.tin = window.localStorage.getItem('tin');
      this.adminService.getRole(this.user.username,this.tin)
         .subscribe((data: any) => {
            if(data){
               this.role = data.role;
               this.isAdmin = this.role === 'Admin';
            }
      });
   }

   ngAfterViewInit() {
      setTimeout(() => {
         this.clickActive = false;
         this.contactType = 'C';
         this.buttonDel.disabled = true;
         this.buttonSite.disabled = true;
         for (const b of this.user.business) {
            if (b.tin === this.tin) {
               this.user_role = b.role;
            }
         }
         this.getGroupList();
      }, 0);
   }

   cultivoChange(item: any) {
      const u = item.type === 'USER' ? 'true' : 'false';
      this.service.put('/work/' + item.siteCode + '/team/' + item.id + '/' + item.role + '?u=' + u, {})
         .subscribe(() => {
            this.protectLast(this.listmember);
         });
   }
   protectLast(item: any) {
      let j = 0;
      for (let i = 0; i < item.length; i++) {
         if (item[i].role === 'Admin') { j++; }
      }
      if (j === 1) { this.show = false; } else { this.show = true; }
   }

   getGroupList() {
      this.loader.show();
      this.service.listCompanyGroup(this.tin, this.filterContactValue)
         .subscribe(
            data => {
               this.bindDataTable(data);
               this.sortData(this.sortEvent);
               this.loader.hide();
            }
         );
   }

   separateData(groups: any[]) {
      this.allGroup = [];
      this.allMember = [];
      let index = 0;
      for(const group of groups){
         const dataMember = {
            no: index + 1,
            ...group
         };
         this.allGroup.push(dataMember);
         index++;
      }
   }

   bindDataTable(data: any) {
      this.listSite = data;
      this.listSite.sort((a: any, b: any) => {
         return a.name.localeCompare(b.name);
      });
      this.separateData(data);
      const dataSiteMember = this.addRowInGroup(this.allGroup);
      this.isLoadingResults = false;
      this.isRateLimitReached = false;
      this.selectedRowIndex = -1;
      this.selection.clear();
      this.buttonDel.disabled = true;
      this.buttonSite.disabled = true;
      this.resultsLength = this.allGroup.length;
      this.dataSource = new MatTableDataSource(dataSiteMember);
      this.dataSource.sort = this.sort;
   }

   addRowInGroup(allGroup: any[]) {
      if (this.paginator.size !== undefined) {
         this.pageSize = this.paginator.size;
      }
      const page_size = this.pageSize;
      const page_number = this.paginator.page;
      let dataSiteMember: any[] = [];
      this.listmember = allGroup.slice(page_number * page_size, page_number * page_size + page_size);
      for (const group of this.listmember) {
         dataSiteMember = dataSiteMember.concat(group);
      }
      return dataSiteMember;
   }

   isGroup(index, item): boolean {
      return item.hasOwnProperty('group');
   }

   groupHeaderClick(row) {
      if (row.expanded === null) {
         return;
      }
      this.selection.clear();
      this.dataSource = new MatTableDataSource<UserData | Group>([]);
      row.expanded = !row.expanded;
      const data = this.addRowInGroup(this.allGroup);
      this.dataSource = new MatTableDataSource(data);
   }

   onSearch(filterValue: string) {
      this.searchFocused = false;
      this.searchvalue = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const value = filterValue.trim();
      if (/[%|^{}[\]\\]/g.test(value)) {
         this.translate.get('alert.create_folder_errors').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         filterValue = filterValue.trim(); // Remove whitespace
         filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
         this.filterContactValue = filterValue;
         this.getGroupList();
      }
   }

   onSearchChange(input: any, e: any) {
      if (e.keyCode !== 13) {
         this.searchFocused = true;
      }

      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const kw = encodeURIComponent(input.value.trim());
      if (kw.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         if (this.timer == null) {
            this.service.listCompanyGroup(this.tin, kw)
               .subscribe(
                  data => {
                     this.separateData(data);
                     if (this.allGroup && this.allGroup.length > 0) {
                        this.searchResult = this.allGroup.slice(0,this.searchSize);
                     } else {
                        this.searchResult = [];
                     }
                  }
               );
         }
      }, 300);
   }

   applyFilter(filterValue: string) {
      const value = filterValue.trim();
      this.selection.clear();
      if (/[%|^{}[\]\\]/g.test(value)) {
         this.translate.get('alert.create_folder_errors').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         filterValue = filterValue.trim(); // Remove whitespace
         filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
         this.filterContactValue = filterValue;
         this.dataSource.filter = this.filterContactValue.trim().toLocaleLowerCase();
      }
   }

   onPageChange() {
      this.selection.clear()
      this.dataSource = new MatTableDataSource<UserData | Group>([]);
      const data = this.addRowInGroup(this.allGroup);
      this.dataSource = new MatTableDataSource(data);
   }

   highlightGroup(row) {
      if (!this.clickActive) {
         this.addgroupDialog = this.dialog.open(AddGroupCompanyComponent, {
            disableClose: true,
            width: '415px'
         });
         this.addgroupDialog.componentInstance.isAddGroup = false;
         this.addgroupDialog.componentInstance.listGroup = this.listmember;
         this.addgroupDialog.componentInstance.permission = row.role;
         this.addgroupDialog.componentInstance.groupNameValue = row.name;
         this.addgroupDialog.componentInstance.tin = row.siteCode;
         this.addgroupDialog.componentInstance.siteName = row.siteName;
         this.addgroupDialog.componentInstance.rowgroup = {
            id: row.id,
            name: row.name,
            type: row.role
         };
         this.service.getMembercompany(row.id)
            .subscribe((data: any) => {
               const members = data.users.map(({id, fullName, authorityType}) => (
                  {
                     id: id,
                     name: fullName,
                     type: authorityType
                  }
               ));
               this.addgroupDialog.componentInstance.members = data.users;
            }, error => {
               this.errorMessage = error;
            });
         this.addgroupDialog.afterClosed().subscribe(result => {
            if (result) {
               this.getGroupList();
            }
         });
         this.selectTabIndex = 0;
      }
      this.clickActive = false;
   }

   selectSearchItem(item) {
      setTimeout(() => {
         this.searchFocused = false;
      }, 100);
      this.searching = item.name.trim();
      let filterValue = this.searching.toLowerCase();
      this.filterContactValue = filterValue;
      this.getGroupList();
   }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.listmember.length;

      this.buttonDel.disabled = numSelected <= 0;
      this.buttonSite.disabled = numSelected <= 0;
      return numSelected === numRows;
   }

   /** Selects all rows if they are not all selected; otherwise clear selection. */
   masterToggle() {
      if (this.isAllSelected()) {
         this.selection.clear();
         this.buttonDel.disabled = true;
         this.buttonSite.disabled = true;
      } else {
         this.dataSource.data.forEach(row => {
            if (!row.hasOwnProperty('group')) {
               this.selection.select(row);
            }
         });
         this.buttonDel.disabled = false;
      }
   }

   disableButton(row: any) {
      if (this.contactType === 'C') {
         const numSelected = this.selection.selected.length;
         if (numSelected > 0) {
            this.buttonDel.disabled = false;
            this.buttonSite.disabled = false;
         } else {
            this.buttonDel.disabled = true;
            this.buttonSite.disabled = true;
         }
         return this.selection.isSelected(row);
      } else {
         return false;
      }
   }

   openContractDialog() {
      this.service.get('/site/' + this.tin)
         .subscribe(() => {
            this.addgroupDialog = this.dialog.open(AddGroupCompanyComponent, {
               disableClose: true,
               width: '415px'
            });
            this.addgroupDialog.componentInstance.listGroup = this.listmember;
            this.addgroupDialog.componentInstance.permission = 'Member';
            this.addgroupDialog.componentInstance.groupNameValue = '';
            this.addgroupDialog.componentInstance.tin = this.tin;
            this.addgroupDialog.componentInstance.members = [];
            this.addgroupDialog.componentInstance.isAddGroup = true;
            this.addgroupDialog.afterClosed().subscribe(result => {
               if (result) {
                  this.getGroupList();
               }
            });
            this.selectTabIndex = 0;
         });
   }

   deleteGroup() {
      const siteName = window.localStorage.getItem('path_company').substring(9);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('main.msg-delete-group').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
         dialogRef.componentInstance.isMsg = true;
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const IdList: GroupData[] = [];
            for (let i = 0; i < this.selection.selected.length; i++) {
               IdList.push({id: this.selection.selected[i].id, name: this.listmember[i].name});
            }
            this.service.deleteGroupCompany(IdList, siteName, this.tin)
               .subscribe(() => {
                  this.translate.get('main.delete-group').subscribe(s => {
                     this.toast.success(s);
                  });
                  this.selection.clear();
                  this.getGroupList();
               }, error1 => {
                  this.toast.error(error1);
               });
         }
      });
   }

   deleteGroupByItem(item: any) {
      const siteName = window.localStorage.getItem('path_company').substring(9);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('main.msg-delete-group').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
         dialogRef.componentInstance.isMsg = true;
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const IdList: GroupData[] = [];
            IdList.push({id: item.id, name: this.listmember[this.selectTabIndex].name});
            this.service.deleteGroupCompany(IdList, siteName, this.tin)
               .subscribe(() => {
                  this.translate.get('main.delete-group').subscribe(s => {
                     this.toast.success(s);
                  });
                  this.selection.clear();
                  this.getGroupList();
               }, error1 => {
                  this.toast.error(error1);
               });
         }
      });
   }

   openAddToSiteDialog(item: any) {
      const usernames = [];
      usernames.push(item.id);
      this.addtositeDialog = this.dialog.open(AddToSiteComponent, {
         disableClose: true,
         width: '400px',
         data: {usernames: usernames, isMember: false}
      });
      this.addtositeDialog.afterClosed().subscribe(result => {
         
      });
   }

   addToSiteDialog() {
      const usernames = this.selection.selected.map(s => s.id)
      this.addtositeDialog = this.dialog.open(AddToSiteComponent, {
         disableClose: true,
         width: '400px',
         data: {usernames: usernames, isMember: false}
      });
      this.addtositeDialog.afterClosed().subscribe(result => {
         
      });
   }

   sortData(e: any) {
      this.sortEvent = e;
      this.allGroup.sort((a: any, b: any) => {
         let comparatorResult = 0;
         switch (e.active) {
           case 'no':
            comparatorResult = b.no - a.no;
            break;
           case 'fullName':
            comparatorResult = a.name.localeCompare(b.name);
            break;
           case 'type':
            comparatorResult = a.type.localeCompare(b.type);
            break;
           case 'members':
            comparatorResult = a.totalMember - b.totalMember;
            break;
         }
         return comparatorResult * (e.direction == 'asc' ? 1 : -1);
      });
      const dataSiteMember = this.addRowInGroup(this.allGroup);
      this.dataSource.data = dataSiteMember;
     }
}

export interface UserData {
   name: string;
   id: string;
   role: string;
   type: string;
}

export interface GroupData {
   name: string;
   id: string;
}
